import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ProjectProvider } from './context/ProjectContext';
import ProjectLanding from './components/ProjectLanding';
import WorkflowStudio from './components/WorkflowStudio';
import './App.css';

function App() {
  return (
    <ProjectProvider>
      <Router>
        <Routes>
          <Route path="/" element={<ProjectLanding />} />
          <Route path="/studio" element={<WorkflowStudio />} />
          <Route path="/studio/:projectId" element={<WorkflowStudio />} />
        </Routes>
      </Router>
    </ProjectProvider>
  );
}

export default App;